module.exports = __webpack_public_path__ + "img/0862196.jpg";